import { validateEmail } from "@superblocksteam/shared";

/**
 * Email check for the "invite and assign" affordance.
 * Reuses the same regex used by the rest of the invite flows so a string
 * like "foo@bar.com,asdf" is correctly rejected as invalid.
 */
export function isValidInviteEmail(value: string): boolean {
  const v = value.trim();
  if (v.length < 5 || v.length > 254) return false;
  return validateEmail(v);
}

export function normalizeInviteEmail(value: string): string {
  return value.trim().toLowerCase();
}

export const INVITE_AND_ASSIGN_DEFAULT_ORG_ROLE_NAME = "Developer";
